export { default } from "./WishlistIcon.jsx";
